import { render } from "@/share/components/controls/fullModal/WrappedTeleport.html?vue&type=template&id=0cc2dbf5&external"
import script from "@/share/components/controls/fullModal/WrappedTeleport.js?vue&type=script&lang=js&external"
export * from "@/share/components/controls/fullModal/WrappedTeleport.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../execute/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__